import CListingChoice from "../listings/CListingChoice";
import {isSet} from "../services/commonUtil";
import {notEmptyArray} from "../services/arrayUtils";

export const CHomeBestListings = props => {
    const {sectionTitle, listings} = props;
    if (!notEmptyArray(listings)) {
        return null;
    }
    return <>
        {isSet(sectionTitle) ? <h2 className="alignCenter">{sectionTitle}</h2> : null}
        <div id="listingsInnerList" className="list-inner">
            <div className="listItems alignCenter">
                {listings
                    .filter(p => p.images && p.images.length > 0)
                    .map(product => {
                        return (
                            <CListingChoice key={product.listing_id}
                                            index={product.listing_id}
                                            product={product}
                            />)
                    })}
            </div>
        </div>
    </>;
}